import React from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, DropdownButtonItem } from '@helix/dropdown-button';
import { TimePeriods } from '../../../../constants';
import { getTimePeriodLabelKey } from '../../../../common/helpers/timePeriods';

const TimePeriodSelector = ({ options, currentValue, setTimePeriod, isDisabled }) => {
	const currentValueOption = getTimePeriodLabelKey(currentValue);
	return (
        <DropdownButton
            label={currentValueOption}
            value={TimePeriods[currentValueOption]}
            removeSplit={true}
            disabled={isDisabled}
            size="small"
        >
            {options?.map((option, index) => (
                <DropdownButtonItem
					id={TimePeriods[option.label]}
                    key={index}
					onClick={({ id }) => setTimePeriod(id)}
                    textLabel={option.label}
                    value={TimePeriods[option.label]}
                >
                    {option.label}
                </DropdownButtonItem>
            ))}
        </DropdownButton>
    );
};

export default TimePeriodSelector;

TimePeriodSelector.propTypes = {
	currentValue: PropTypes.string,
	setTimePeriod: PropTypes.func
};
